// Please keep the enum sorted alphabetically
export enum FeatureFlags {
  ACCESS_RYST_INCENTIVES = 'ACCESS_RYST_INCENTIVES',
  AGILYSYS_DOD_CENTRIC = 'AGILYSYS_DOD_CENTRIC',
  AMAZON_INTEGRATION = 'AMAZON_INTEGRATION',
  ANNOUNCEMENT_BUTTON_LINK = 'ANNOUNCEMENT_BUTTON_LINK',
  ANNOUNCEMENT_MULTI_SITE_SELECTION = 'ANNOUNCEMENT_MULTI_SITE_SELECTION',
  ANNOUNCEMENTS_SITE_VISIBILITY_TOGGLES = 'ANNOUNCEMENTS_SITE_VISIBILITY_TOGGLES',
  AUTO_PUSH_TOGGLE = 'CDL-22813-auto-push-toggle',
  AVRIDE_ROBOT_DELIVERY = 'AVRIDE_ROBOT_DELIVERY',
  BE_PASSWORD_GENERATION = 'BE_PASSWORD_GENERATION',
  BULK_UPDATE_ATTACH_ITEM_MODIFIER = 'BULK_UPDATE_ATTACH_ITEM_MODIFIER',
  BUNDLE_FIXED_PRICE_DISCOUNTS = 'BUNDLE_FIXED_PRICE_DISCOUNTS',
  BUSINESS_UNIT_EDGE_DELETION = 'BUSINESS_UNIT_EDGE_DELETION',
  BUY_X_GET_Y_DISCOUNTS = 'BUY_X_GET_Y_DISCOUNTS',
  BUY_X_GET_Y_FREE_DISCOUNTS = 'BUY_X_GET_Y_FREE_DISCOUNTS',
  CANADA_REFUNDS_ENABLED = 'CDL-10248-allow-canada-refunds',
  CATALOG_BACKUP_VERSION_EXPORT = 'catalog-backup-version-export',
  CDL_28980_PI_MITIGATION = 'CDL-28980-PI-Mitigation',
  CENTRIC_BROWSE_DISCOVER = 'centric-browse-discover',
  CENTRIC_HOME_OVERVIEW_SITE = 'centric-home-overview-site',
  CENTRIC_MOBILE_ORDER_BROWSING = 'centric-mobile-order-browsing',
  CENTRIC_USER_MANAGEMENT = 'centric-user-management',
  CENTRIC_HUB_VISIBLE = 'CENTRIC_HUB_VISIBLE',
  CPG_ITEM_UPLOAD = 'CDL-18946-CPG-upload',
  CREATE_MODIFY_STATION_DISCOUNTS = 'CREATE_MODIFY_STATION_DISCOUNTS',
  DISCOUNT_THIRD_PARTY_CHANNELS_NEXTEP = 'DISCOUNT_THIRD_PARTY_CHANNELS_NEXTEP',
  DISCOUNT_THIRD_PARTY_CHANNELS_AGILYSYS = 'DISCOUNT_THIRD_PARTY_CHANNELS_AGILYSYS',
  DISPLAY_REPORTING_DIAGNOSTICS = 'DISPLAY_DATA_DIAGNOSTICS',
  MARKETING_ROLE = 'MARKETING_ROLE',
  EXTENDED_NUTRITION_DISPLAY = 'extended_nutrition_display',
  FORECASTING_PAGINATION = 'FORECASTING_PAGINATION_OAPI-1193',
  GENERATIVE_AI = 'generative-ai',
  GENERATIVE_AI_V2 = 'GENERATIVE_AI_V2',
  GLOBAL_MENU_MANAGEMENT = 'global_menu_management',
  GLOBAL_ACTIVITY_LOG = 'global-activity-log',
  GRUB_HUB_CENTRIC_INTEGRATION = 'GRUB_HUB_CENTRIC_INTEGRATION',
  JWO_MENU_INTEGRATION = 'JWO-Menu-Integration',
  LABS = 'centric-labs',
  LUNA = 'luna',
  LUNA_CHAT = 'luna-chat',
  LUNA_MENUWORKS = 'luna-menuworks',
  LUNA_MODIFIERS = 'luna-modifiers',
  MANAGE_ANNOUNCEMENTS = 'MANAGE_ANNOUNCEMENTS',
  MANAGE_MARKETING = 'MANAGE-MARKETING',
  MARKETPLACE_DROP_OFF = 'MARKETPLACE_DROP_OFF',
  MEALPLAN_HEALTH = 'MEALPLAN_HEALTH',
  MENU_COST_FIELD = 'MENU_COST_FIELD',
  MENU_LABELS = 'menu_labels',
  MENU_LABELS_SEQUENCE = 'MENU_LABELS_SEQUENCE',
  MENU_PARTNER_SYNC_REVISION_SKIP = 'MENU_PARTNER_SYNC_REVISION_SKIP',
  MENU_REORDERING = 'MENU_REORDERING',
  MENU_STATUS_AGILYSYS = 'MENU-STATUS-AGILYSYS',
  MENU_STATUS_AGILYSYS_DOD = 'MENU-STATUS-AGILYSYS-DOD',
  MENU_STATUS_AMAZON = 'MENU_STATUS_AMAZON',
  MENU_STATUS_GRUB_HUB = 'MENU_STATUS_GRUBHUB',
  MENU_STATUS_ILLUMIA = 'MENU-STATUS-ILLUMIA',
  MENU_STATUS_MASHGIN = 'MENU-STATUS-MASHGIN',
  MENU_STATUS_TIME2EAT = 'MENU-STATUS-TIME2EAT',
  MENU_TABLE_CUSTOMIZATION = 'MENU_TABLE_CUSTOMIZATION',
  MENU_V2_MENUWORKS_ICONS = 'MENU_V2_MENUWORKS_ICONS',
  MENU_VISIBILITY_SETTINGS = 'MENU_VISIBILITY_SETTINGS',
  MENUWORKS_MENU_CYCLE_IMPORT = 'MENUWORKS_MENU_CYCLE_IMPORT',
  MENUWORKS_PRODUCTS_BROWSER = 'MENUWORKS_PRODUCTS_BROWSER',
  MENUWORKS_V2 = 'CDL-19289-Menuworks-v2',
  MODIFIER_CREATE_MENUWORKS = 'MODIFIER-CREATE-MENUWORKS',
  MRN_POPUPS_REMOVAL = 'MRN_POPUPS_REMOVAL',
  NEXTEP_STATION_ALLOW_DISABLE_MENU = 'Nextep-Station-Allow-Disable-Menu',
  NEXTEP_ORDER_STREAMING = 'NEXTEP_ORDER_STREAMING',
  ORDER_SEARCH_BAR = 'ORDER_SEARCH_BAR',
  OVERVIEW_SNAPSHOT = 'overview-snapshot',
  REPORTING_SALES_MIX_2 = 'REPORTING_SALES_MIX_2',
  REVENUE_OPTIMIZED_MENUS = 'revenue-optimized-menus',
  SCANNER = 'CDL-18134-scanner',
  SHOW_REVIEWS = 'SHOW-REVIEWS',
  SINGLE_ITEMS_PERCENT_OFF = 'SINGLE_ITEMS_PERCENT_OFF',
  SITE_ACTIVITY_LOG = 'SITE_ACTIVITY_LOG',
  SITE_GROUPING = 'SITE-GROUPING',
  TIME2EAT_INTEGRATION_UPDATE = 'TIME2EAT_INTEGRATION_UPDATE',
  TRAKER_IN_CENTRIC = 'traker-in-centric',
  RYST_CENTRIC_INTEGRATION = 'RYST_CENTRIC_INTEGRATION',
  UPDATED_REFUND_WORKFLOW = 'UPDATED_REFUND_WORKFLOW',
  USE_BRAND_PREPUBLISH_VALIDATION = 'CDL-24341-USE_BRAND_PREPUBLISH_VALIDATION',
  USE_EDGE_BOOST_THRIVE_UPDATE = 'USE_EDGE_BOOST_THRIVE_UPDATE',
  USE_TYPED_CONFIG_ROUTES = 'USE_TYPED_CONFIG_ROUTES',
  USE_V4_BRAND_PREPUBLISH_VALIDATION = 'USE_V4_BRAND_PREPUBLISH_VALIDATION',
  V4_MENU = 'CDL-20309-V4-Menu-Composite',
  V4_MODIFIER_GROUP_ITEMS_TAB = 'V4_MODIFIER_GROUP_ITEMS_TAB',
  VERTEX_ENABLED = 'VERTEX_ENABLED',
  VIEW_CENTRIC_MENU_AGENT = 'VIEW_CENTRIC_MENU_AGENT',
  VIEW_CENTRIC_MENU_AGENT_VOICE = 'VIEW_CENTRIC_MENU_AGENT_VOICE',
  VIEW_VENDORS = 'VIEW_VENDORS',
  VOLANTE_MEAL_PLAN_TAX_TAGS = 'VOLANTE_MEAL_PLAN_TAX_TAGS',
  VOUCHERIFY_REPLACEMENT = 'VOUCHERIFY_REPLACEMENT',
}
